import React, {Component} from 'react'
import {Link} from 'react-router'
import {prefixLink} from 'gatsby-helpers'

const Header = () => {
  return (
    <header className='header z2 mx-auto flex-auto'>
      <Link className='home-link' to={prefixLink('/')}>
        <img src='../images/raunch.svg' className='logo'/>
      </Link>
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./components/Header.js